import React from "react";

import './Faq.css';

import ContactCard from '../../../shared/components/ContactCard/ContactCard';



const Faq = props => {

    return (
        <>
        {/* <section className="Faq__main-container" id="faq">
            <div className="Faq__faqs-container">   
                <div className="Faq__faqs columns faqs">
                    {faqs.map((faq, index) => (
                        <Accordion faq={faq} index={index} key={index} toggleFAQ={toggleFAQ}></Accordion>
                    ))}
                </div>
            </div>
        </section> */}
        <section>
            <div className="Faq__customer-service-container">
                <ContactCard/>
            </div> 
        </section>
        </>

    );
};

export default Faq;